import {
  SheetPageBody,
  SheetPageClose,
  SheetPageTitle,
} from "@/components/ui/sheet-page"
import { useShowProps } from "./page-props"
import Flash from "@/components/ui/flash"
import { MailPlus } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function Page() {
  const { t } = useTranslation(["team_applications"])
  const {
    team_application: { team_profile_name },
  } = useShowProps()

  return (
    <SheetPageBody>
      <SheetPageTitle icon={MailPlus}>
        {t("team_applications:team_application.title", { team_profile_name })}
      </SheetPageTitle>
      <div className="flex flex-col gap-6 p-6">
        <Flash />
        <SheetPageClose>Close</SheetPageClose>
      </div>
    </SheetPageBody>
  )
}
